import React from 'react'

import Title from 'components/CommonUI/Title/Title'
import HelpSupportForm from './components/HelpSupportForm'
import HelpSupportContacts from './components/HelpSupportContacts'
import Spinner from 'components/CommonUI/Spinner/Spinner'
import SuccessHelpSupportModal from 'pages/HelpSupport/components/SuccessHelpSupportModal'
import {useShallowEqualSelector} from 'custom-hooks'
import {getIsFetchingSelector} from 'redux/reducers/profile'

const HelpSupport = () => {

    const isFetching = useShallowEqualSelector(getIsFetchingSelector)
    return (
        <div className="help-support-container">
            <div className="help-support-wrapper">
                <div className="help-support-header">
                    <Title title="Help & Support"/>
                </div>
                <div className="help-support-holder">
                    <HelpSupportContacts/>
                </div>
                <div className="form-container">
                    <HelpSupportForm/>
                </div>
            </div>
            <SuccessHelpSupportModal />
            {isFetching && <Spinner />}
        </div>
    )
}

export default HelpSupport
